import { graphConfig } from "../authProvider";

export async function GetProfilePhoto(token: string, personId?: string) {
  const res = await fetch(
    personId
      ? `https://graph.microsoft.com/v1.0/users/${personId}/photo/$value`
      : graphConfig.graphGetPhotoSmall,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  let photo: Blob | undefined;
  if (res.status === 200) photo = await res.blob();
  return photo;
}

export async function GenerateMeetingLink(
  token: string,
  subject: string,
  startDateTime: Date,
  endDateTime: Date
): Promise<string | null> {
  const res = await fetch("https://graph.microsoft.com/v1.0/me/onlineMeetings", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      startDateTime: startDateTime.toISOString(),
      endDateTime: endDateTime.toISOString(),
      subject,
    }),
  });

  if (res.status !== 201 && res.status !== 200) {
    console.error("Error creating meeting:", await res.text());
    return null;
  }

  const data = await res.json();
  return data?.joinWebUrl || null;
}

export async function GetUserName(personId: string, token: string) {
  const res = await fetch(
    `https://graph.microsoft.com/v1.0/users/${personId}?$select=displayName`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const username = await res.json();
  return username;
}

export interface GraphUser {
  id: string;
  displayName: string;
  mail: string | null;
  userPrincipalName: string;
  department: string | null;
}

const ALLOWED_DEPARTMENTS = ["it", "technology", "shipping"];

export async function SearchUsers(token: string, query: string): Promise<GraphUser[]> {
  if (!query.trim()) return [];

  const departmentFilter = ALLOWED_DEPARTMENTS
    .map((d) => `department eq '${d}'`)
    .join(" or ");

  const filter = `accountEnabled eq true and (${departmentFilter})`;

  const params = new URLSearchParams({
    "$search": `"displayName:${query}"`,
    "$filter": filter,
    "$select": "id,displayName,mail,userPrincipalName,department",
    "$top": "10",
    "$count": "true",
    "$orderby": "displayName",
  });

  const res = await fetch(
    `https://graph.microsoft.com/v1.0/users?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        ConsistencyLevel: "eventual",
      },
    }
  );

  if (!res.ok) return [];
  const data = await res.json();
  return data.value ?? [];
}